// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const BankTransferIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "BankTransfer/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13 6h10a.998.998 0 0 0 .625-1.78l-5-4a1.001 1.001 0 0 0-1.25 0l-5 4A.999.999 0 0 0 13 6Zm5-3.719L20.149 4H15.85L18 2.281ZM24 9V7H12v2h1v2h-1v2h12v-2h-1V9h1Zm-9 0h2v2h-2V9Zm6 2h-2V9h2v2ZM1 17h10a.998.998 0 0 0 .625-1.78l-5-4a1.001 1.001 0 0 0-1.25 0l-5 4A.999.999 0 0 0 1 17Zm5-3.719L8.149 15H3.851L6 13.281ZM0 20h1v2H0v2h12v-2h-1v-2h1v-2H0v2Zm3 0h2v2H3v-2Zm6 2H7v-2h2v2ZM5 10l3-3H6V4h3v2l3-3-3-3v2H5a1 1 0 0 0-1 1v4H2l3 3Z"
}));
export default BankTransferIcon;